import React from 'react';
import PropTypes from 'prop-types';
import {withContext, getContext} from 'recompose';

export const AuthProvider = withContext(
    {
        currentParticipant: PropTypes.any.isRequired
    },
    ({currentParticipant}) => ({currentParticipant})
)(
    ({children}) => React.Children.only(children)
);

export const withAuth = getContext({
    currentParticipant: PropTypes.any.isRequired
});
